<main id="main-wrapper">
    <div class="master-grid">
        <div class="t-row">
            <div class="col c--12">
                <div class="content-in ct-lg">
                    <h1 class="central-title p-ttl">{{ post.title }}</h1>

                    <div class="meta-art">
                        <span class="date-p"><i class="fas fa-calendar"></i> {{ post.pubdate | date:"dd/MM/yyyy" }}</span>&nbsp;
                        <span class="date-p" title="Temps de lecture"><i class="fas fa-clock"></i> {{ post.timeread }} minute.s</span>&nbsp;
                        <span class="date-p btn-back" (click)="goBack()"><i class="fas fa-arrow-left"></i> Retour</span>
                    </div>

                    <figure class="frst-il">
                        <img src="{{ post.image }}" alt="astuces" class="wpp">
                    </figure>
                </div>
                <div class="content-in ct-lg">
                    <div class="normal-txt-in" [innerHTML]="post.content">
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>